export const userLimitsKeys = {
    all: ['user-limits'] as const,
    limits: () => [...userLimitsKeys.all, 'limits'] as const,
    confirmations: () => [...userLimitsKeys.all, 'confirmations'] as const,
};
